import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { Notification } from '@ezugi/types';

const initialState: Notification[] = [];

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    add(_state, { payload }: PayloadAction<Notification>) {
      return [ payload ];
    },
    remove([ _first, ...state ]) {
      return state;
    },
  },
});

export const notificationActions = notificationSlice.actions;
export default notificationSlice.reducer;
